import { PRODUCTS } from "@/data/products";
import { useCart } from "@/context/CartContext";

export const ScentGrid = () => {
  const { addItem } = useCart();

  return (
    <section
      id="scents"
      data-testid="scent-grid-section"
      className="py-20 px-6 max-w-6xl mx-auto border-b border-[var(--line)]"
    >
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="label-caps text-[11px] text-[var(--ink)]/70">The Four Offerings</span>
        <h2 className="serif-head text-3xl sm:text-4xl text-[var(--ink)] mt-2 mb-3">
          Scent Formulations
        </h2>
        <p className="text-xs text-[var(--ink)]/75 font-light leading-relaxed">
          Infused with natural essential oils to hydrate, refresh, and project natural magnetism.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PRODUCTS.map((product) => (
          <div
            key={product.slug}
            data-testid={`product-card-${product.slug}`}
            className="border border-[var(--line)] p-5 bg-[var(--card-bg)] flex flex-col justify-between"
          >
            <div className="relative aspect-square border border-[var(--line)] mb-4 overflow-hidden">
              <img
                src={product.image}
                alt={product.imageAlt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover dr1-kenburns"
              />
            </div>
            <div>
              <div className="label-caps text-[9px] text-[var(--ink)]/60">{product.tag}</div>
              <h3 className="serif-head text-xl text-[var(--ink)] mt-1">{product.name}</h3>
              <p className="text-xs text-[var(--ink)]/70 mt-2 mb-4 font-light">
                {product.description}
              </p>
              <div className="pt-3 border-t border-[var(--line)] flex items-center justify-between">
                <span className="mono-num text-xs font-semibold text-[var(--ink)]">
                  ${product.price}
                </span>
                <button
                  type="button"
                  data-testid={`add-to-cart-${product.slug}`}
                  onClick={() => addItem(product.slug)}
                  className="border border-[var(--ink)] px-3 py-1.5 label-caps text-[9px] text-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--bg)] transition-colors"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
